import Polyfill from "../Polyfill";
import {Helpers} from "../../../common/js/Helpers";

function updatePaymentForSelectedField() {

    let paymentInputFields = document.querySelectorAll('input[name=paymentid]');

    for(let i=0; i<paymentInputFields.length; i++) {
        let field = paymentInputFields[i];
        let paymentBody = Helpers.getParent(field, '.payment-container').querySelector('.payment-body');

        if (field.checked) {
            document.dispatchEvent(Polyfill.createNewEvent('eventgallery.payment.selected', {field}));
            if (paymentBody) {
                paymentBody.style.display = 'block';
            }
        } else {
            document.dispatchEvent(Polyfill.createNewEvent('eventgallery.payment.unselected', {field}));
            if (paymentBody) {
                paymentBody.style.display = 'none';
            }
        }
    }
}

function updateShippingForSelectedField() {

    let shippingInputFields = document.querySelectorAll('input[name=shippingid]');

    for(let i=0; i<shippingInputFields.length; i++) {
        let field = shippingInputFields[i];
        let shippingBody = Helpers.getParent(field, '.shipping-container').querySelector('.shipping-body');

        if (field.checked) {
            if (shippingBody) {
                shippingBody.style.display = 'block';
            }
        } else {
            if (shippingBody) {
                shippingBody.style.display = 'none';
            }
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {

    // Handle Payment
    let paymentInputFields = document.querySelectorAll('input[name=paymentid]');

    for(let i=0; i<paymentInputFields.length; i++) {
        paymentInputFields[i].addEventListener('click', ()=> {
            updatePaymentForSelectedField()
        })
    }

    updatePaymentForSelectedField();

    // Handle Shipping

    let shippinginputFields = document.querySelectorAll('input[name=shippingid]');
    for(let i=0; i<shippinginputFields.length; i++) {
        shippinginputFields[i].addEventListener('click', ()=> {
            updateShippingForSelectedField()
        })
    }

    updateShippingForSelectedField();
});




